import {api} from "../../services";
import Swal from "sweetalert2";

const groups = {
  state: {
    data: [],
    edit_group: {
      id: null,
      name: null,
      channels: []
    },
    new_group: {
      name: null,
      channels: []
    },
    field_new_group: false,
    field_edit_group: false,
    modal_loading: false,
  },
  getters: {
    getGroupObject: (state) => (key, value) => {
      const object = state.data.find(item => {
        return item[`${key}`] === value;
      });
      return object === undefined ? {} : object;
    },
    getGroupsArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    },
    /*getChannelsGroupsArray: (state) => (key, value) => {
      if (state.data !== undefined) {
        return state.data.filter(item => {
          return item.status_key > 0 && item.parameter.modules.campaign === 1;
        });
      }
      return [];
    },*/
  },
  mutations: {
    SET_GROUPS_DATA(state, payload) {
      state.data = payload
    },
    SET_NEW_GROUP(state, payload) {
      state.new_group = payload
    },
    SET_EDIT_GROUP(state, payload) {
      state.edit_group = payload
    },
    SET_FIELD_NEW_GROUP(state, payload) {
      state.field_new_group = payload
    },
    SET_FIELD_EDIT_GROUP(state, payload) {
      state.field_edit_group = payload
    },
    SET_MODAL_LOADING(state, payload) {
      state.modal_loading = payload
    },
  },
  actions: {
    getGroups(context) {
      api.get('/groups').then(response => {
        context.commit("SET_GROUPS_DATA", response.data);
        this.dispatch('stopModalLoading')
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao buscar grupos',
            showConfirmButton: false,
            timer: 2000
          })
        }
      });
    },
    /*getGroup(context, payload) {
      api.get(`/groups/${payload}`).then(response => {
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },*/
    addGroup(context, payload) {
      api.post('/groups', payload).then(response => {
        Swal.fire({
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_1234'),
          showConfirmButton: false,
          timer: 2000
        })
        this.dispatch("getGroups")
        context.commit('SET_EDIT_GROUP', response.data)
        context.commit("SET_NEW_GROUP", { name: null, channels: [] });
        context.commit('SET_FIELD_NEW_GROUP', false)
        context.commit('SET_FIELD_EDIT_GROUP', true)
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    updateGroup(context, payload) {
      api.put(`/groups/${payload.id}`, payload).then((response) => {
        this.dispatch('getGroups')
        context.commit("SET_EDIT_GROUP", response.data);
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_933'),
          showConfirmButton: false,
          timer: 2000
        })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },
    deleteGroup(context, payload) {
      api.delete(`/groups/${payload}`).then((response) => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: context.rootGetters.getTranslations('expression_1235'),
          showConfirmButton: false,
          timer: 2000
        })
        this.dispatch('getGroups')
        context.commit('SET_EDIT_GROUP', { id: null })
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },

    /*Buscar canais do grupo*/
    /*getGroupChannels(context, payload) {
      api.get(`/groups/${payload}/channels`).then(response => {
        context.commit("SET_EDIT_GROUP_CHANNELS", response.data);
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },*/
    /*Adiciona canal no grupo*/
    /*addChannelInGroup(context, payload) {
      api.post(`/groups/${payload.id}/channels`).then(response => {
        context.commit("SET_NEW_GROUP_CHANNEL", response.data);
        setTimeout(() => {
          Swal.fire({
            icon: 'success',
            title: context.rootGetters.getTranslations('expression_345'),
            showConfirmButton: false,
            timer: 2000
          })
        }, 1000)
      }).catch(error => {
        if (error.response.status === 401) {
          this.dispatch('logoutUser');
        }
      });
    },*/
    startModalLoading(context) {
      context.commit("SET_MODAL_LOADING", true);
    },
    stopModalLoading(context) {
      context.commit("SET_MODAL_LOADING", false);
    },
  },
}
export default groups;
